import React from "react";
import './index.scss';

const AboutToken = () => {
    return(
        <div className='aboutToken'>
            <div className='aboutToken-infoBlock'>
                <div className='aboutToken-infoBlock-title'>Game Design and Narrative Development</div>
                <div className='aboutToken-infoBlock-text'>
                    Our designers and storytellers work together to <span className="tp">shape every aspect</span> of the player experience. They design mechanics that <span className="text-pink">feel fresh</span> and <span className="tpink">intuitive</span>, create levels that challenge and surprise, and craft <span className="tpink">compelling narratives</span> that anchor our games. Their goal is to ensure every game we make feels <span className="tp">cohesive</span>, <span className="tp">meaningful</span>, and <span className="tp">truly memorable</span>.
                </div>
            </div>
            <div className='aboutToken-infoBlock'>
                <div className='aboutToken-infoBlock-title'>Art and Animation</div>
                <div className='aboutToken-infoBlock-text'>
                    From concept sketches to fully <span className="tp">animated characters</span>, they focus on detail, style, and emotion. Animators add movement that feels <span className="tp">natural and expressive, </span>ensuring every frame contributes to the game’s world, whether it’s a serene 2D environment or a vibrant, dynamic 3D space.
                </div>
            </div>
            <div className='aboutToken-infoBlock'>
                <div className='aboutToken-infoBlock-title'>Programming and Technical Development</div>
                <div className='aboutToken-infoBlock-text'>
                    CBX systems power our games, from <span className="tp">gameplay mechanics</span> to rendering engines. They ensure smooth performance, adapt <span className="tp">cutting-edge technology</span>, and solve complex challenges to make sure our games are as seamless to play as they are <span className="tp">ambitious to create</span>.
                </div>
            </div>
            <div className='aboutToken-infoBlock'>
                <div className='aboutToken-infoBlock-title'>Player Immersion Experts</div>
                <div className='aboutToken-infoBlock-text'>
                    Our sound <span className="tp">designers and composers</span> craft audio that draws players into our worlds—every footstep, whisper, and sweeping soundtrack has purpose. Paired with UX/UI design that feels <span className="tp">intuitive and inviting</span>, we ensure players are not just playing a game, but stepping into an experience they’ll <span className="tp">remember</span>.
                </div>
            </div>
            <div className='aboutToken-infoBlock'>
                <div className='aboutToken-infoBlock-title'>Innovation and Player Experience</div>
                <div className='aboutToken-infoBlock-text'>
                    This team is the heart of Cloudbox’s mission to <span className="tp">push boundaries</span>. By listening to player feedback, analyzing how our games are played, and experimenting with new ideas, they ensure <span className="tp">we’re always evolving</span>. They keep us connected to our audience and focused on delivering games that surprise, delight, and <span className="tp">set new standards</span> for the industry.
                </div>
            </div>
            <div className='aboutToken-infoBlock'>
                <div className="inner-wrap">
                    <div className='aboutToken-infoBlock-circle first' />
                    <div className='aboutToken-infoBlock-circle second' />
                    <div className='aboutToken-infoBlock-circle third' />
                    <div className='aboutToken-infoBlock-circle fourth' />
                    <div className='aboutToken-infoBlock-circle fifth' />
                    <div className='aboutToken-infoBlock-circle sixth' />
                </div>
            </div>

        </div>
    )
}

export default AboutToken;
